import React from "react";
import { ModalProvider } from "react-modal-hook";
import { Redirect, Route, Switch } from "react-router-dom";
import { RESOURCE_NAME } from "common/authorization";
import { getPath } from "common/routing";
import { isRootSubdomain } from "common/utils/url";
import { withAuthorization } from "../Authorization/withAuthorization";
import DownloadExport from "../Exports/DownloadExport";
import AccountDashboardShim from "./AccountsApp/AccountDashboardShim";
import AdminLandingPage from "./AdminLandingPage";
import CreateAccount from "./CreateAccount";
import CsvImports from "./CsvImports";
import TranscriptionApp from "./TranscriptionApp";

export default function AdminApp() {
  const isOnRootSubdomain = isRootSubdomain(window.location.href);

  return isOnRootSubdomain ?
      <div>
        <ModalProvider>
          <Switch>
            <Redirect exact from="/" to="/admin" />
            <Route path="/admin/tasks" component={TranscriptionApp} />
            <Route path="/admin/accounts/create" component={CreateAccount} />
            <Route
              path={getPath("downloadExport")}
              component={DownloadExport}
            />
            <Route
              path="/admin/csv-imports/:importType"
              component={withAuthorization(CsvImports, {
                resource: RESOURCE_NAME.SCRIPT_JOB,
                permission: "dispatch",
              })}
            />
            <Route path="/admin" component={AdminLandingPage} />
          </Switch>
        </ModalProvider>
      </div>
    : <ModalProvider>
        <Route path="/" component={AccountDashboardShim} />
      </ModalProvider>;
}
